import { Injectable } from "@angular/core";
import {
  AcceptOrganizationLinkInvitationGQL,
  CreateOrganizationLinkInvitationGQL,
  DeclineOrganizationLinkInvitationGQL,
  DeleteOrganizationLinkInvitationGQL,
  GetOrganizationLinkInvitationByTokenGQL,
  GetOrganizationLinkInvitationsOutgoingGQL,
  OrganizationLinkInvitationAcceptInput,
  OrganizationLinkInvitationCreateInput,
  OrganizationLinkInvitationFragment,
  OrganizationLinkInvitationIdInput,
  OrganizationLinkInvitationStatus,
  OrganizationLinkInvitationTokenInput,
  ResendOrganizationLinkInvitationGQL,
} from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class OrganizationLinkInvitationService {
  constructor(
    private readonly outgoing: GetOrganizationLinkInvitationsOutgoingGQL,
    private readonly byToken: GetOrganizationLinkInvitationByTokenGQL,
    private readonly createInvitation: CreateOrganizationLinkInvitationGQL,
    private readonly resendInvitation: ResendOrganizationLinkInvitationGQL,
    private readonly deleteInvitation: DeleteOrganizationLinkInvitationGQL,
    private readonly acceptInvitation: AcceptOrganizationLinkInvitationGQL,
    private readonly declineInvitation: DeclineOrganizationLinkInvitationGQL
  ) {}

  /** `statuses` omitted/empty returns invitations of every status; see the resolver's doc comment. */
  getOutgoing(
    organizationId: string,
    statuses?: OrganizationLinkInvitationStatus[]
  ): Observable<OrganizationLinkInvitationFragment[]> {
    return this.outgoing
      .fetch({ organizationId, statuses }, { fetchPolicy: "network-only" })
      .pipe(map((x) => x.data.getOrganizationLinkInvitationsOutgoing));
  }

  getByToken(input: OrganizationLinkInvitationTokenInput): Observable<OrganizationLinkInvitationFragment> {
    return this.byToken
      .fetch({ input }, { fetchPolicy: "network-only" })
      .pipe(map((x) => x.data.getOrganizationLinkInvitationByToken));
  }

  create(input: OrganizationLinkInvitationCreateInput): Observable<OrganizationLinkInvitationFragment> {
    return this.createInvitation.mutate({ input }).pipe(map((x) => x.data.createOrganizationLinkInvitation));
  }

  resend(input: OrganizationLinkInvitationIdInput): Observable<OrganizationLinkInvitationFragment> {
    return this.resendInvitation.mutate({ input }).pipe(map((x) => x.data.resendOrganizationLinkInvitation));
  }

  withdraw(input: OrganizationLinkInvitationIdInput): Observable<boolean> {
    return this.deleteInvitation
      .mutate({ input })
      .pipe(map((x) => x.data.deleteOrganizationLinkInvitation.status));
  }

  accept(input: OrganizationLinkInvitationAcceptInput): Observable<OrganizationLinkInvitationFragment> {
    return this.acceptInvitation.mutate({ input }).pipe(map((x) => x.data.acceptOrganizationLinkInvitation));
  }

  decline(input: OrganizationLinkInvitationTokenInput): Observable<OrganizationLinkInvitationFragment> {
    return this.declineInvitation.mutate({ input }).pipe(map((x) => x.data.declineOrganizationLinkInvitation));
  }
}
